import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestModel } from 'src/app/typings/typing';
@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(private http: HttpClient) {}
  prefix = '/eshop_backend'
  // export file
  exportToExcel(url: string): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(`${url}`, { headers, observe: 'response', responseType: 'blob' });
  }
   downloadFile(id: string): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(`${this.prefix}/file/download/${id}`, { headers, responseType: 'blob'});
  }
   previewFile(id: string) {
    return this.http.get<RequestModel>(`${this.prefix}/file/preview/${id}`);
  }
}
